import useAuthUser from "@/composables/useAuthUser";
import useHasPermissionUser from "@/composables/useHasPermissionUser";
import { RouteRecordRaw } from "vue-router";

export default {
  path: "/companies",

  children: [
    {
      path: "",
      name: "companies.index",
      beforeEnter: (to, from, next) => {
        const { user } = useAuthUser();

        if (user.value?.internal) {
          return next({
            name: "companies.index.internal",
          });
        } else {
          return next();
        }
      },
      component: () => import("@/modules/companies/pages/IndexPage.vue"),
    },
    {
      path: ":name/:id",
      name: "companies.view",
      component: () => import("@/modules/companies/pages/ViewPage.vue"),
      beforeEnter: (to, from, next) => {
        const { user } = useAuthUser();

        if (user.value?.internal) {
          return next({
            name: "companies.view.internal",
            params: {
              name: to.params.name,
              id: to.params.id,
            },
          });
        } else {
          return next();
        }
      },
    },
    {
      path: "edit/:id",
      name: "companies.edit",
      component: () => import("@/modules/companies/pages/EditPage.vue"),
      beforeEnter: (to, from, next) => {
        const { hasPermissionUser } = useHasPermissionUser();
        const { user } = useAuthUser();

        if (user.value?.internal) {
          return next({
            name: "companies.edit.internal",
            params: {
              id: to.params.id,
            },
          });
        } else {
          return next();
        }
      },
    },
    {
      path: "create/:id?",
      name: "company.create",
      component: () => import("@/modules/companies/pages/CreatePage.vue"),
      beforeEnter: (to, from, next) => {
        const { user } = useAuthUser();

        if (!user.value?.internal) {
          return next({
            path: "/error/not-found",
          });
        } else {
          return next();
        }
      },
    },
  ],
} as RouteRecordRaw;
